import { render, staticRenderFns } from "./NewEditSeriePage.vue?vue&type=template&id=2a477f31&"
import script from "./NewEditSeriePage.vue?vue&type=script&lang=js&"
export * from "./NewEditSeriePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports